/**
 * 课程评价列表功能
 * @Author:wuTao
 * @Date 2021/04/02
 */
import React from 'react';
import { connect } from 'dva';
import { reduxTemplateConfig, templateConfig } from './config';

import { component_tool, framework_tool, utils_tool } from '@/tool'
import { WizModalUserIdentityShow } from '@/containers/common';

let { checkStrLength, Session } = utils_tool;
let { WizSpin, WizBrowserExport, WizModal, WizRow, WizCol, WizButton, WizRate, WizInput } = component_tool;
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
import { Descriptions } from 'antd'

const getProgramEvaluation = (history) => {
  let record = {}
  if (history.location) {
    let pathname = '/program/programList'
    if (history.location.pathname && history.location.pathname.startsWith('/perm/programPerm/programList')) {
      pathname = '/perm/programPerm/programList'
    }
    if (history.location.pathname === pathname + '/programEvaluation') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('programEvaluationInfo', record)
      } else {
        record = Session.get('programEvaluationInfo') || 0
      }
    }
  } else {
    record = Session.get('programEvaluationInfo') || 0
  }
  return record
}

class ProgramEvaluation extends WizContainer {

  componentName = 'programEvaluation';

  constructor(props) {
    super(props);
    const { history } = props;
    this.state = {
      studentProgramEvaluationRecord: {},
      showUserPersonInfoVisible: false,
      selectedStudentProgramEvaluationRows: [],//选择的学员评语
      selectedRows: 0,
      programCommentVisible: false,
      programCommentList: [],
      programComment: {},
      nextFlag: false,
      time: new Date().getTime()
    };
    this.initialValue = getProgramEvaluation(props.history);
  }

  propsAndStateOnChange = {
    reviewComment: this._reviewCommentOver.bind(this)
  }

  _getCommentInfo(apiParams = {}) {
    let initialValue = this.initialValue;
    const { id } = initialValue;
    this.doAction({
      path: 'comment/commentMarkDetailPageList',
      payload: {
        key: 'comment@commentMarkDetailPageList',
        apiParams: {
          pageNum: 1, pageSize: 10,  bizIdList:[id],bizType: 0
        }
      }
    })
  }

  _reviewCommentOver(nextProps, nextState) {
    if (nextProps.reviewComment.code === 1) {
      let {data, success, msg} = nextProps.reviewComment
      if (success) {
        if (data && !data?.id) {
          this.setState({programCommentVisible: false, time: new Date().getTime(),reviewReason: ''})
          this._getCommentInfo()
        } else {
          this._next()
        }
      } else {
        wizNotice.error(msg || '操作失败,请稍后尝试')
      }
    } else {
        wizNotice.error((nextProps.reviewComment && nextProps.reviewComment.msg) || '操作失败,请稍后尝试')
    }
    return true
}

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleStudentProgramEvaluation(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }
  _handleChangeScreen(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _list(nextProps, nextState, key) {
    let o = nextProps[key] || {}
    let { code, success, msg, data } = o
    if (success) {
      let list = data.records;
      let listNew = []
      list && list.length && list.forEach(element => {
        if (element.commentMobile !== '' && element.commentMobile !== null && element.commentMobile !== undefined) {
          element.commentMobile = element.commentMobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
        }
        listNew.push(element);
      });
      return listNew;
    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  _handleBatchReviewPre(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      let {data} = o
      if (data && data.length) {
        let p = data.sort((a, b) => b.id - a.id)
        if (data.length > 1) {
          this.setState({ nextFlag: true })
        }
        this.setState({ programCommentVisible: true, programComment: p[0], programCommentList: data, time: new Date().getTime() })
      }
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _reviewComment(id, state) {
    let { reviewReason, programCommentList } = this.state
    let ids = programCommentList.map(i => i.id)
    this.doAction({
      path: "comment/reviewComment",
      payload: {
        key: "comment@reviewComment",
        apiParams: {
          id: id,
          state: state,
          reviewReason: reviewReason,
          ids: ids
        },
      },
    });
  }

  _next = () => {
    let { programCommentList, nextFlag, programComment } = this.state
    if (programCommentList && programCommentList.length > 1) {
      nextFlag = true
    } else {
      nextFlag = false
    }
    let p = programCommentList.sort((a, b) => b.id - a.id)
    let rows = programCommentList.filter(i => i.id != programComment.id)
    this.setState({ programCommentVisible: true, programComment: p[1], programCommentList: rows, nextFlag, time: new Date().getTime() })
  }

  showProgramCommentModal() {
    let { programCommentVisible, programComment, programCommentList, nextFlag, time } = this.state
    if (programCommentList && programCommentList.length == 1) {
      nextFlag = false
    }
    let { score, content, commentUserName, commentFullName, orgName, orgCode } = programComment
    let footerBtn =
      <WizRow className="apply-button-row">
        <WizCol>
          <WizButton title='通过' type='primary' onClick={() => {
            this.setState({ programCommentVisible: false, time: new Date().getTime() })
            this._reviewComment(programComment.id, 1)
          }}>通过</WizButton>
          <WizButton title='未通过' type='danger' onClick={() => {
            this.setState({ programCommentVisible: false, time: new Date().getTime() })
            this._reviewComment(programComment.id, 2)
            }}>未通过</WizButton>
          {nextFlag ?
            <WizButton title='下一个' onClick={() => {
              this.setState({ programCommentVisible: false, time: new Date().getTime() })
              this._next()
            }}>下一个</WizButton> : null}
        </WizCol>
      </WizRow>
    return (
      <WizModal title='课程评论详情'
        destroyOnClose
        key={time}
        width={700}
        visible={programCommentVisible}
        footer={footerBtn}
        onCancel={() => { this.setState({ programCommentVisible: false, time: new Date().getTime(), reviewReason: '' }) }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
          <div style={{ width: '500px' }}>
          <Descriptions column={2}>
          <Descriptions.Item label='账号'>{commentUserName}</Descriptions.Item>
              <Descriptions.Item label='姓名'>{commentFullName}</Descriptions.Item>
              <Descriptions.Item label='组织'>{orgName}</Descriptions.Item>
              <Descriptions.Item label='组织编码'>{orgCode}</Descriptions.Item>
            </Descriptions>
            <Descriptions column={1}>
              <Descriptions.Item label="评论评分">
                <WizRate allowHalf value={score} />
              </Descriptions.Item>
              <Descriptions.Item label="评论内容">{content}</Descriptions.Item>
              <Descriptions.Item label="审核信息">
                <WizInput.TextArea rows={3} cols={50}
                  maxLength={200}
                  placeholder='请输入审核信息,最多200字'
                  onBlur={(e) => { this.setState({ reviewReason: e.target.value }) }}
                />
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>
      </WizModal>
    )
  }

  _render() {
    //初始化路径评语ID
    const { showUserPersonInfoVisible, studentProgramEvaluationRecord } = this.state;
    let initialValue = this.initialValue;
    const { id } = initialValue;

    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedStudentProgramEvaluationRows: rows,
          selectedRows: rows.length
        });
      },
      _this: this,
      programId: id,
      _btnLookUserFun: (e) => {
        if (e.record) {
          this.setState({
            studentProgramEvaluationRecord: e.record,
            showUserPersonInfoVisible: true,
          })
        }
      },
      _btnLookProgramEvaluationFun: (e) => {
        if (e.record) {
          this.setState({
            studentProgramEvaluationRecord: e.record,
          })
        }
      }
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      programId: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        changeScreen: this._handleChangeScreen.bind(this),
        changeScreenBatch: this._handleChangeScreen.bind(this),
        list: this._list,
        batchReviewPre: this._handleBatchReviewPre.bind(this),
      },
    });
    let lookUserPersonInfoModal = {
      title: '查看任职',
      visible: showUserPersonInfoVisible,
      personId: studentProgramEvaluationRecord.commentPerson ? studentProgramEvaluationRecord.commentPerson : null,
      orgId: null,
      positionId: null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          studentProgramEvaluationRecord: {},
        });
      },
    };
    return (
      <>
        <WizReduxTemplate {..._reduxTemplateConfig} />
        <WizModalUserIdentityShow {...lookUserPersonInfoModal} />
        {this.showProgramCommentModal()}
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { comment } = state
  const reviewComment = modelUtils.getModelEntity(comment, 'comment@reviewComment')
  const load = modelUtils.getLoadingState(state, 'comment')
  return {
    reviewComment,
    ...load
  }
};

export default connect(mapStateToProps)(ProgramEvaluation);
